import { render, staticRenderFns } from "./SfTableData.vue?vue&type=template&id=8f5a6222&"
import script from "./SfTableData.vue?vue&type=script&lang=ts&"
export * from "./SfTableData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports